exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Sliders .items .Item{position:relative}.Sliders .items .Item .count-slider{position:absolute;background:#00adff;color:#fff;padding:5px;z-index:9}.Sliders .items .Item .checkbox-item{position:absolute;z-index:9;right:5px;top:2px}.Sliders .items .Item .ItemImage{width:100%;height:100%;background-position:50%;background-size:contain;background-repeat:no-repeat}.Sliders .items .Item .ItemQuestion{padding:10px;display:flex;justify-content:center}.Sliders .items .Item .ItemQuestion img{max-width:100%;max-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Presentation/components/Sliders/components/Item/style.scss
// module id = 5071
// module chunks = 0